import { toast } from 'sonner';

/**
 * App toasts (DESIGN_SYSTEM §4): success disappears after 3 s, errors stay until dismissed.
 * Add a "View" action when the toast is about something the user can open.
 */
interface ToastAction {
  label: string;
  onClick: () => void;
}

interface NotifyOptions {
  /** Replace an existing toast, e.g. the one returned by `notify.loading`. */
  id?: string | number;
  description?: string;
  action?: ToastAction;
}

export const SUCCESS_TOAST_MS = 3000;

function options(opts: NotifyOptions | undefined, duration: number) {
  return {
    duration,
    ...(opts?.id !== undefined ? { id: opts.id } : {}),
    ...(opts?.description ? { description: opts.description } : {}),
    ...(opts?.action ? { action: opts.action } : {}),
  };
}

export const notify = {
  success: (message: string, opts?: NotifyOptions) =>
    toast.success(message, options(opts, SUCCESS_TOAST_MS)),
  error: (message: string, opts?: NotifyOptions) =>
    toast.error(message, options(opts, Number.POSITIVE_INFINITY)),
  info: (message: string, opts?: NotifyOptions) =>
    toast.info(message, options(opts, SUCCESS_TOAST_MS)),
  /** Spinner toast for slow work; resolve it with `notify.success/error(…, { id })`. */
  loading: (message: string) => toast.loading(message),
  dismiss: (id?: string | number) => toast.dismiss(id),
};
